import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useStripe } from '../../contexts/StripeContext';
import SubscriptionManager from '../SubscriptionManager';

const SubscriptionGuard = ({ children }) => {
  const { loading } = useStripe();

  const [showSubscriptionManager, setShowSubscriptionManager] = useState(false);

  // Show loading state while checking subscription
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Always allow access - free tier users can use the app with limits
  return (
    <>
      {children}

      {/* Subscription Manager Modal */}
      {showSubscriptionManager && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <SubscriptionManager
              onClose={() => setShowSubscriptionManager(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};

SubscriptionGuard.propTypes = {
  children: PropTypes.node.isRequired
};

export default SubscriptionGuard;
